import styled from 'styled-components';
import { grey } from 'styles/Colors';

export const Span = styled.span`
  font-family: Lato;
  font-size: 13px;
  line-height: 1.23;
  letter-spacing: 0.5px;
  text-align: center;
  color: ${grey};
  display: block;
`;

export const PlaceholderText = styled(Span)`
  margin-bottom: 30px;
`;

export const UpperLabel = styled.div`
  width: 63px;
  height: 8px;
  border-radius: 3px;
  background-color: #d8d8d8;
  padding: 0;
`;

export const LowerLabel = styled.div`
  width: 47px;
  height: 8px;
  border-radius: 3px;
  background-color: #eeeeee;
  padding: 0;
`;

export const ScoreLabel = styled(Span)`
  font-size: 19.5px;
  font-weight: 500;
  text-align: left;
  padding: 0;
`;

export const PlaceholderCard = styled.div`
  width: 81px;
  height: 53px;
  border-radius: 3px;
  border: solid 0.9px rgba(207, 207, 207, 0.7);
  margin: auto;
  padding: 7px;
  margin-bottom: 10px;
`;

export const PlayListPlaceholder = styled.div`
  width: 150px;
  padding: 5px;
  svg {
    display: block;
    margin: auto;
    margin-bottom: 10px;
  }
`;
